import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPlaceByIdAPI } from "api/placeApi";
import { DeletePlaceAPI } from "api/placeApi";
import { updatePlaceAPI } from "api/placeApi";
import { assignSettingAPI } from "api/placeApi";
import { getPlaceAPI } from "api/placeApi";
import { createPlaceAPI } from "api/placeApi";
import { updateHelpMessageAPI } from "api/placeApi";
import { get } from "lodash";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  creatingPlace: false,
  placeCreated: false,
  err: null,
  placeData: [],
  selectedPlace: {},
  multiSelectedPlaces: [],
  placesList: [],
  singlePlace: {},
  totalPlaces: 0,
  loading: false,
};

export const updateHelpMessage = createAsyncThunk(
  "place/updateHelpMessage",
  async (placeData, { rejectWithValue }) => {
    try {
      const response = await updateHelpMessageAPI(placeData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const createPlace = createAsyncThunk(
  "place/createPlace",
  async (placeData, { rejectWithValue }) => {
    try {
      const response = await createPlaceAPI(placeData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getPlaces = createAsyncThunk(
  "place/getPlaces",
  async (data, { rejectWithValue }) => {
    try {
      const response = await getPlaceAPI();
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getPlaceById = createAsyncThunk(
  "place/getPlaceByIdAPI",
  async (placeId, { rejectWithValue }) => {
    try {
      const response = await getPlaceByIdAPI(placeId);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const assignSetting = createAsyncThunk(
  "place/assignSetting",
  async (updatePlaceData, { rejectWithValue }) => {
    try {
      const response = await assignSettingAPI(updatePlaceData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const updatePlace = createAsyncThunk(
  "place/updatePlace",
  async (updatePlaceData, { rejectWithValue }) => {
    try {
      const response = await updatePlaceAPI(updatePlaceData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const deletePlace = createAsyncThunk(
  "place/deletePlace",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DeletePlaceAPI(data);
      return response.data;
    } catch (err) {
      console.log("Delete err ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

const placeSlice = createSlice({
  name: "place",
  initialState,
  reducers: {
    resetPlaceState: (state) => {
      state.creatingPlace = false;
      state.placeCreated = false;
      state.err = null;
    },
    setPlaceData: (state, action) => {
      state.placeData = action.payload;
    },
    setSelectedPlace: (state, action) => {
      state.selectedPlace = action.payload;
    },
    setMultiSelectedPlaces: (state, action) => {
      state.multiSelectedPlaces = action.payload;
    },
    setSinglePlace: (state, action) => {
      state.singlePlace = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPlace.pending, (state) => {
        state.creatingPlace = true;
        state.placeCreated = false;
        state.err = null;
      })
      .addCase(createPlace.fulfilled, (state) => {
        state.creatingPlace = false;
        state.placeCreated = true;
        state.err = null;
      })
      .addCase(createPlace.rejected, (state, action) => {
        state.creatingPlace = false;
        state.placeCreated = false;
        state.err = action.payload;
      })
      .addCase(getPlaces.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPlaces.fulfilled, (state, { payload }) => {
        const places = get(payload, "places", []);
        state.placesList = places;
        state.placeData = places;
        state.totalPlaces = get(payload, "total", 0);
        state.loading = false;

        // ✅ Sync selectedPlace so checklist/PlacePicker always shows fresh setup data
        if (state.selectedPlace?._id) {
          const fresh = places.find(
            (p) => p._id?.toString() === state.selectedPlace._id?.toString()
          );
          if (fresh) state.selectedPlace = fresh;
        }
      })
      .addCase(getPlaces.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const {
  resetPlaceState,
  setPlaceData,
  setSelectedPlace,
  setMultiSelectedPlaces,
  setSinglePlace,
} = placeSlice.actions;
export default placeSlice.reducer;
